import { namespacedConsts } from '../../utils/object'
import { appDispatcher } from '../../application/AppDispatcher'

const CONSTS = namespacedConsts({
  ROUTER: {
    ACTIONS: {
      ROUTE_CHANGED: true,
    },
  },
})

export const TYPES = CONSTS.ROUTER.ACTIONS

export const routeChanged = route => {
  appDispatcher.dispatchAction.window({
    type: TYPES.ROUTE_CHANGED,
    route,
  })
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/actions/routerActions.js